import * as React from "react";
import { useFormikContext, useField } from "formik";
import { TimeUnitInput } from "components/common";
import { ErrorMessage } from "./ErrorMessage";
const HelpOrError = ({ help, errorMessage, touched }) => {
  if (errorMessage && touched) return /* @__PURE__ */ React.createElement(ErrorMessage, null, errorMessage);
  return help;
};
function FormikTimeUnitInput({
  field,
  label = void 0,
  units = void 0,
  clearable = false,
  required = false,
  disabled = false,
  showCheckbox = false,
  help = void 0
}) {
  const { setFieldValue, values, errors, touched, setFieldTouched } = useFormikContext();
  const [{ name }] = useField({ name: field.name });
  const updateTimes = (newTime, newUnit) => {
    if ((values || {})[name] !== newTime) setFieldValue(name, newTime);
    if ((values || {})[`${name}_unit`] !== newUnit) setFieldValue(`${name}_unit`, newUnit);
    setTimeout(() => {
      setFieldTouched(name, true);
      setFieldTouched(`${name}_unit`, true);
    }, 10);
  };
  return /* @__PURE__ */ React.createElement(
    TimeUnitInput,
    {
      label,
      name,
      unitName: `${name}_unit`,
      update: updateTimes,
      value: (values || {})[name],
      unit: (values || {})[`${name}_unit`],
      units,
      clearable,
      required,
      enabled: !disabled,
      hideCheckbox: !showCheckbox,
      help: /* @__PURE__ */ React.createElement(HelpOrError, { help, errorMessage: (errors || {})[name], touched: (touched || {})[name] })
    }
  );
}
export default FormikTimeUnitInput;
